import svg from './svg.js'
import img from './img.js'

export const icons = {
	svg,
	img
};

export default icons